<template>
  <div>
    <div class="lightbox" v-if="visible" @click="show = false;">
      <div class="flex">
        <div class="" @click.stop="prev" :class="{ invisible: !hasPrev() }">
          <svg
            class="lightbox-arrow lightbox-prev"
            fill="#fff"
            height="48"
            viewBox="0 0 24 24"
            width="48"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z" />
            <path d="M0-.5h24v24H0z" fill="none" />
          </svg>
        </div>
        <!-- START IMAGE -->
        <div class="lightbox-image" @click.stop="">
          <img :src="images[indeksFromParent]" loading="lazy"/>
        </div>
        <!-- END IMAGE -->
        <div
          class="lightbox-arrow lightbox-next"
          @click.stop="next"
          :class="{ invisible: !hasNext() }"
        >
          <svg
            class="pointer-events-none"
            fill="#fff"
            height="48"
            viewBox="0 0 24 24"
            width="48"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z" />
            <path d="M0-.25h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <div class="lightbox-title">{{ this.caption[indeksFromParent] }}</div>
      <!-- <div class="lightbox-subtitle">
        <i class="lni lni-user"></i> {{ this.pembuat }} &nbsp;
        <i class="lni lni-calendar"></i> {{ this.waktu_buat }}
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    images: {
            type: Array,
            default: () => [],
    },
    pembuat: {
            type: String,
            default: '',
    },
    waktu_buat: {
            type: String,
            default: '',
    },
    nama: {
            type: String,
            default: '',
    },
    caption: {
            type: Array,
            default: () => [],
    },
    indeksFromParent: Number,
    visible: Boolean,
  },
  data() {
        return {
            index: 0,
        };
    },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(visible) {
        this.$emit("clicked", visible);
        this.index = 0;
      },
    },
  },
  methods: {
    hasNext() {
      return this.index + 1 < this.images.length;
    },
    hasPrev() {
      return this.index - 1 >= 0;
    },
    prev() {
            if (this.hasPrev()) {
                this.index -= 1;
                this.$emit('decrease', 1)
            }
        },
    next() {
            if (this.hasNext()) {
                this.index += 1;
                this.$emit('increase', 1)
            }
        },
    hide(){ this.show = false },
    onKeydown(e) {
      if (this.visible) {
        switch (e.key) {
          case "ArrowRight":
            this.next();
            break;
          case "ArrowLeft":
            this.prev();
            break;
          case "ArrowDown":
          case "ArrowUp":
          case " ":
            e.preventDefault();
            break;
          case "Escape":
            this.hide();
            break;
        }
      }
    },
  },
  mounted() {
    window.addEventListener("keydown", this.onKeydown);
  },
  unmounted() {
    window.removeEventListener("keydown", this.onKeydown);
  },
};
</script>
<style>
.lightbox {
  position: fixed;
  z-index: 1000;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
}

.lightbox-arrow {
  position: absolute;
  top: 50%;
  z-index: 515;
  background: rgba(0, 0, 0, 0.3);
}

.lightbox-title {
  padding: 12px;
  font-size: large;
  position: absolute;
  text-align: justify;
  bottom: 10%;
  z-index: 515;
  color: white;
  background: rgba(0, 0, 0, 0.8);
  justify-content: center;
  align-items: center;
}

.lightbox-subtitle {
  font-size: small;
  position: absolute;
  text-align: justify;
  bottom: 6%;
  z-index: 520;
  color: white;
  justify-content: left;
}

.lightbox-prev {
  left: 15%;
}

.lightbox-next {
  right: 15%;
}

.lightbox-image img {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: calc(100vh - 90px);
  
}
</style>
